import Navbar from "./components/Navbar";
import ParticleHero from "./components/ParticleHero";

export default function Home() {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <ParticleHero />
    </div>
  );
}